// @flow
import { format } from "date-fns"
import * as R from "ramda"

import type { PassengerFormObject } from "booking/services/reservation/types"

// Returns date string in in YYYY-MM-DD format
export default (pax: PassengerFormObject) => {
  const values = ["birthYear", "birthMonth", "birthDay"].reduce((acc, field) => {
    // $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
    acc[field] = Number(R.pathOr("", [field, "value"], pax))
    return acc
  }, {})

  // Return empty string if we can't construct a valid date
  if (!values.birthYear || !values.birthMonth || !values.birthDay) return ""

  const date = new Date(
    values.birthYear,
    values.birthMonth - 1, // Month is indexed from 0
    values.birthDay,
  )

  return format(date, "YYYY-MM-DD")
}
